<template>
    <div class="main-container">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }" id="sidebar">
            <div class="sidebar-header">
                <h2 class="sidebar-title">图层控制</h2>
                <div style="display: flex;justify-items: start;align-items: center;">
                    <input type="checkbox" class="layer-checkbox" style="margin-right: 0.5rem" v-model="allSelected" @change="onAllSelect" />
                    <button class="toggle-btn" @click="toggleSidebar">
                        <span>{{ toggleIcon }}</span>
                    </button>
                </div>
            </div>
            <div class="search-box">
                <input type="text" class="search-input" placeholder="搜索管网编号、名称..." v-model="searchTerm" @input="handleSearch">
            </div>
            <div class="layer-control">
                <div class="layer-group">
                    <div class="layer-group-title">
                        <span>污水图层</span>
                    </div>
                    <div class="layer-item" v-for="(item, index) in filteredPipeLayers" :key="index" @click="toggleLayer(item)">
                        <input type="checkbox" class="layer-checkbox" v-model="item.checked" @input="e => onChange(item.name, e.target.checked)" @click.stop />
                        <div class="layer-icon" :style="{ background: item.checked ? item.bgColor1 : item.bgColor }">
                            <img class="layer-icon-img" :src="item.icon" alt="" :style="{ opacity: item.checked ? 1 : 0.7 }"/>
                        </div>
                        <span class="layer-name">{{ item.name }}</span>
                    </div>
                </div>
                <div class="layer-group">
                    <div class="layer-group-title">
                        <span>雨水图层</span>
                    </div>
                    <div class="layer-item" v-for="(item, index) in filteredFacilityLayers" :key="index" @click="toggleLayer(item)">
                        <input type="checkbox" class="layer-checkbox" v-model="item.checked" @input="e => onChange(item.name, e.target.checked)" @click.stop/>
                        <div class="layer-icon" :style="{ background: item.checked ? item.bgColor1 : item.bgColor }">
                            <img class="layer-icon-img" :src="item.icon" alt="" :style="{ opacity: item.checked ? 1 : 0.7 }"/>
                        </div>
                        <span class="layer-name">{{ item.name }}</span>
                    </div>
                </div>
                <div class="layer-group">
                    <div class="layer-group-title">
                        <span>其他图层</span>
                    </div>
                    <div class="layer-item" v-for="(item, index) in filteredMonitoringLayers" :key="index" @click="toggleLayer(item)">
                        <input type="checkbox" class="layer-checkbox" v-model="item.checked" @input="e => onChange(item.name, e.target.checked)" @click.stop />
                        <div class="layer-icon" :style="{ background: item.checked ? item.bgColor1 : item.bgColor }">
                            <img class="layer-icon-img" :src="item.icon" alt="" :style="{ opacity: item.checked ? 1 : 0.7 }"/>
                        </div>
                        <span class="layer-name">{{ item.name }}</span>
                    </div>
                </div>
            </div>
        </aside>
    </div>
</template>

<script>
export default {
    props: {
        selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isCollapsed: false,
            toggleIcon: '◀',
            pipeLayers: [
                { name: '污水收集区', checked: true, icon: '/icons/sewage-scope.png', bgColor: 'rgba(161, 121, 0, 0.2)', bgColor1: 'rgba(161, 121, 0, 0.6)', color: '#007bff' },
                { name: '污水管网', checked: true, icon: '/icons/sewage-pipe.png', bgColor: 'rgba(161, 121, 0, 0.2)', bgColor1: 'rgba(161, 121, 0, 0.6)', color: '#00ff96' },
                { name: '污水检查井', checked: true, icon: '/icons/sewage-well.png', bgColor: 'rgba(161, 121, 0, 0.2)', bgColor1: 'rgba(161, 121, 0, 0.6)', color: '#ffc107' }
            ],
            facilityLayers: [
                { name: '雨水管网', checked: true, icon: '/icons/sewage-scope.png', bgColor: 'rgba(35,144,253,0.2)', bgColor1: 'rgba(35,144,253, 0.6)' },
                { name: '雨水排口', checked: true, icon: '/icons/rain-outlet.png', bgColor: 'rgba(35,144,253,0.2)', bgColor1: 'rgba(35,144,253, 0.6)' },
                { name: '雨水检查井', checked: true, icon: '/icons/sewage-well.png', bgColor: 'rgba(35,144,253,0.2)', bgColor1: 'rgba(35,144,253, 0.6)' }
            ],
            monitoringLayers: [
                { name: '截流设施', checked: true, icon: '/icons/intercepting-well.png', bgColor: 'rgba(30,203,61,0.2)', bgColor1: 'rgba(30,203,61,0.6)' },
                // { name: '液位计', checked: true, icon: '/icons/liquid.png', bgColor: 'rgba(255,123,1,0.2)', bgColor1: 'rgba(255,123,1,0.6)' },
                // { name: '流量计', checked: true, icon: '/icons/flow.png', bgColor: 'rgba(254,51,186,0.2)', bgColor1: 'rgba(254,51,186,0.6)' },
                // { name: '雨量计', checked: true, icon: '/icons/rain.png', bgColor: 'rgba(0,179,252,0.2)', bgColor1: 'rgba(0,179,252,0.6)' },
                { name: '水质监测站', checked: true, icon: '/icons/water-quality.png', bgColor: 'rgba(150,40,246,0.2)', bgColor1: 'rgba(150,40,246,0.6)' },
                { name: '视频监控', checked: true, icon: '/icons/monitor.png', bgColor: 'rgba(0,199,175,0.2)', bgColor1: 'rgba(0,199,175,0.6)' },
                { name: '泵站信息', checked: true, icon: '/icons/pump.png', bgColor: 'rgba(216,61,0,0.2)', bgColor1: 'rgba(216,61,0,0.6)' }
            ],
            searchTerm: '',
        };
    },
    computed: {
        allSelected: {
            get() {
                const allLayers = [...this.pipeLayers, ...this.facilityLayers, ...this.monitoringLayers];
                return allLayers.every(layer => layer.checked);
            },
            set(value) {
                const allLayers = [...this.pipeLayers, ...this.facilityLayers, ...this.monitoringLayers];
                allLayers.forEach(layer => {
                    layer.checked = value;
                    this.onChange(layer.name, value);
                });
            }
        },
        filteredPipeLayers() {
            return this.pipeLayers.filter(item => item.name.includes(this.searchTerm));
        },
        filteredFacilityLayers() {
            return this.facilityLayers.filter(item => item.name.includes(this.searchTerm));
        },
        filteredMonitoringLayers() {
            return this.monitoringLayers.filter(item => item.name.includes(this.searchTerm));
        },
    },
    methods: {
        toggleSidebar() {
            this.isCollapsed = !this.isCollapsed;
            this.toggleIcon = this.isCollapsed ? '▶' : '◀';
            this.$emit('sidebar-toggle', this.isCollapsed);
        },
        toggleLayer(layer) {
            layer.checked = !layer.checked;
            this.onChange(layer.name, layer.checked);
        },
        handleSearch() {
            console.log('搜索:', this.searchTerm);
        },
        onChange(name, value) {
            if (value) {
                if (!this.selected.includes(name)) {
                    this.selected.push(name);
                }
            } else {
                const index = this.selected.indexOf(name);
                this.selected.splice(index, 1);
            }
            this.$emit("change", this.selected);
        },
        onAllSelect() {
            const allLayers = [...this.pipeLayers, ...this.facilityLayers, ...this.monitoringLayers];
            const allChecked = this.allSelected;
            allLayers.forEach(layer => {
                layer.checked = allChecked;
                this.onChange(layer.name, allChecked);
            });
        }
    }
};
</script>
<style scoped>
* {
    padding: 0;
    margin: 0;
}

.main-container {
    position: fixed;
    display: flex;
    height: 100vh;
    z-index:99;
}

/* 侧边栏 */
.sidebar {
    width: 320px;
    background: rgba(10, 14, 39, 0.95);
    border-right: 1px solid rgba(0, 255, 150, 0.2);
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
}

.sidebar.collapsed {
    width: 60px;
}

.sidebar-header {
    height: 60px;
    padding:0 15px;
    border-bottom: 1px solid rgba(0, 255, 150, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-title {
    font-size: 1.1rem;
    color: #00ff96;
    transition: opacity 0.3s ease;
}

.sidebar.collapsed .sidebar-title {
    display: none;
}

.toggle-btn {
    background: rgba(0, 255, 150, 0.1);
    border: 1px solid rgba(0, 255, 150, 0.3);
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #00ff96;
    padding: 5px;
}

.toggle-btn:hover {
    background: rgba(0, 255, 150, 0.2);
    border-color: #00ff96;
}

/* 搜索框 */
.search-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(0, 255, 150, 0.2);
    padding: 10px 0;
}

.search-input {
    width: 90%;
    padding: 10px 5px;
    background: rgba(20, 35, 70, 0.6);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 8px;
    color: #fff;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.search-input:focus {
    outline: none;
    border-color: #00ff96;
    box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}

.sidebar.collapsed .search-box {
    display: none;
}

/* 图层控制 */
.layer-control {
    flex: 1;
    overflow-y: auto;
    padding: 0.8rem;
}

.layer-group {
    margin-bottom: 1rem;
}

.layer-group-title {
    font-size: 0.9rem;
    color: #94a3b8;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.layer-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    /*padding: 0.5rem;*/
    margin-bottom: 0.5rem;
    background: rgba(20, 35, 70, 0.3);
    border-radius: 6px;
    transition: all 0.3s ease;
    cursor: pointer;
    height: 40px;
}

.layer-item:hover {
    background: rgba(20, 35, 70, 0.5);
}

.layer-checkbox {
    width: 18px;
    height: 18px;
    accent-color: #00ff96;
    margin-left: 10px;
}

.layer-icon {
    width: 25px;
    height: 25px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
}
.layer-icon-img {
    width: 15px;
    height: 15px;
}

.layer-name {
    flex: 1;
    font-size: 0.9rem;
    color: #e2e8f0;
}

.sidebar.collapsed .layer-group-title,
.sidebar.collapsed .layer-checkbox,
.sidebar.collapsed .layer-name
{
    display: none;
}
</style>